exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel {\r\n  text-transform: uppercase;\n}\n#main form input[type=\"email\"] {\r\n  background-color: #ffffff;\r\n  background-image: none;\r\n  border: 1px solid #cccccc;\r\n  border-radius: 4px;\r\n  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset;\r\n  color: #555555;\r\n  display: block;\r\n  font-size: 14px;\r\n  height: 34px;\r\n  line-height: 1.42857;\r\n  padding: 6px 12px;\r\n  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;\r\n  width: 100%;\n}\n.multiselect__input {\r\n  border: unset !important;\n}\n.multiselect__input:focus {\r\n  border: 1px solid #cccccc !important;\n}\r\n", ""]);

// exports
